import { render, staticRenderFns } from "./MyFeedBack.vue?vue&type=template&id=4a41d734&scoped=true"
import script from "./MyFeedBack.vue?vue&type=script&lang=js"
export * from "./MyFeedBack.vue?vue&type=script&lang=js"
import style0 from "./MyFeedBack.vue?vue&type=style&index=0&id=4a41d734&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a41d734",
  null
  
)

export default component.exports